module.exports = __webpack_public_path__ + "img/06.fa011921.png";